import store from "@/store"

// Global flag to prevent duplicate initialization
let hasInitializedBugsnag = false
let BugsnagInstance: any

const ReportError = {
  async install(Vue: any) {
    const apiKey = process.env.VUE_APP_BUGSNAG_API_KEY

    if (!apiKey) {
      console.warn("ReportError environment variable not set")
      return
    }

    if (
      hasInitializedBugsnag ||
      (window as any).Bugsnag ||
      window != window.top // Prevent intialization in iframes
    )
      return

    const { default: Bugsnag } = await import("@bugsnag/js")
    const { default: BugsnagPluginVue } = await import("@bugsnag/plugin-vue")
    const { default: BugsnagPerformance } = await import(
      "@bugsnag/browser-performance"
    )

    BugsnagInstance = Bugsnag

    BugsnagInstance.start({
      apiKey,
      releaseStage: process.env.VUE_APP_ENV || "development",
      plugins: [new BugsnagPluginVue()],
      onError: function(event: any) {
        const user = store.getters["auth/currentUser"]
        const app = store.getters["app"]

        if (user) event.setUser(user.id, user.email, user.name)
        if (app)
          event.addMetadata("app", {
            subdomain: app.slug,
            name: app.name,
            url: app.url
          })
      }
    })

    BugsnagInstance.getPlugin("vue")?.installVueErrorHandler(Vue)

    BugsnagPerformance.start({
      apiKey,
      releaseStage: process.env.VUE_APP_ENV || "development"
    })

    hasInitializedBugsnag = true

    Vue.prototype.$reportError = async (err: Error) => {
      try {
        await BugsnagInstance.notify(err, (event: any) => {
          event.addMetadata("custom", {
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            url: window.location.href
          })
        })
      } catch (error) {
        console.error("Failed to ReportError:", error)
      }
    }
  }
}

export default ReportError
